import {
  getEngagementPromoAPI,
  postEngagementPromoAPI,
  putEngagementPromoAPI,
  deleteEngagementPromoAPI,
} from "../api";

export default {
  namespaced: true,

  state: {
    data: {
      engagementPromos: [],
      isLoading: false,
    },
  },

  getters: {
    getEngagementPromos: (state) => state.data.engagementPromos,
    getPromoLoading: (state) => state.data.isLoading,
  },

  actions: {
    actionGetEngagementPromos({ commit, rootState }) {
      const { env } = rootState.selectEnv.data;
      commit("SET_IS_LOADING", true);
      return new Promise((resolve, reject) => {
        getEngagementPromoAPI(env).then(
          (response) => {
            commit("SET_ENGAGEMENT_PROMO", response);
            setTimeout(() => {
              commit("SET_IS_LOADING", false);
            }, 1000);
            resolve(response);
          },
          (error) => {
            setTimeout(() => {
              commit("SET_IS_LOADING", false);
            }, 1000);
            reject(error);
          }
        );
      });
    },

    actionSetEngagementPromo({ commit }, payload) {
      commit("SET_IS_LOADING", true);
      if (payload && !payload.eventKey) {
        return new Promise((resolve, reject) => {
          postEngagementPromoAPI(payload)
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              setTimeout(() => {
                commit("SET_IS_LOADING", false);
              }, 1000);
              console.log("err: ", err);
              reject(err);
            });
        });
      } else {
        return new Promise((resolve, reject) => {
          putEngagementPromoAPI(payload)
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              setTimeout(() => {
                commit("SET_IS_LOADING", false);
              }, 1000);
              console.log("err: ", err);
              reject(err);
            });
        });
      }
    },

    actionDeleteEngagementPromo({ commit }, payload) {
      commit("SET_IS_LOADING", true);
      return new Promise((resolve, reject) => {
        deleteEngagementPromoAPI(payload)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            setTimeout(() => {
              commit("SET_IS_LOADING", false);
            }, 1000);
            console.log("err: ", err);
            reject(err);
          });
      });
    },
  },

  mutations: {
    SET_ENGAGEMENT_PROMO(state, payload) {
      state.data.engagementPromos = payload;
    },
    SET_IS_LOADING(state, payload) {
      state.data.isLoading = payload;
    },
  },
};
